module.exports = __webpack_public_path__ + "static/img/tu11.a335bf6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/spzx_xqy/tu11.png
// module id = JmRQ
// module chunks = 1